import { Link } from 'react-router-dom';
import PaginaEsito from './PaginaEsito';

// Pagina di ringraziamento dopo la registrazione. Si apre da sola a registrazione riuscita e si puo` richiamare a mano
// per vederla: /grazie-registrazione
const GrazieRegistrazione = () => (
    <PaginaEsito titolo="Grazie per esserti registrato">
        <p>Grazie per esserti registrato a SportId Manager®.</p>
        <p>Ti abbiamo mandato un'e-mail con il link per validare il tuo indirizzo. Potrai accedere con la password temporanea che trovi nell'e-mail.</p>
        <Link to="/login" className="btn btn-primary btn-add d-inline-flex justify-content-center mt-2">Vai al login</Link>
    </PaginaEsito>
);

export default GrazieRegistrazione;
